import { render, staticRenderFns } from "./TopBarActions.vue?vue&type=template&id=571eb04b&scoped=true"
import script from "./TopBarActions.vue?vue&type=script&lang=js"
export * from "./TopBarActions.vue?vue&type=script&lang=js"
import style0 from "./TopBarActions.vue?vue&type=style&index=0&id=571eb04b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571eb04b",
  null
  
)

export default component.exports